module.exports = __webpack_public_path__ + "static/media/Course Dashboard.c5f105c9.png";